import { Injectable } from '@angular/core';
import { RequestService } from './request.service';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AmplitudeService {
  sessionId = Date.now();

  constructor(private requestService: RequestService) {}

  public logEvent(eventInput: string, eventProperties?: { [key: string]: unknown }): void {
    this.requestService
      .post(`/amplitude/track`, {
        eventInput,
        eventProperties,
        eventOptions: {
          session_id: this.sessionId,
          platform: 'Web',
          time: Date.now()
        }
      })
      .then()
      .catch((error: HttpErrorResponse) => console.error(error));
  }
}
